import React from 'react';
import tipsIcon from 'assets_vacanted/icons/tips_icon.png';
import vStyles from '../../Vacantest.module.css';

const tips = [
  {
    title: '¿No encuentras tu ciudad?',
    content: 'Estamos trabajando para sumar más ciudades en los próximos meses. Te mantendremos informado.',
  },
  {
    title: '¿Es correcta tu ubicación? ',
    content: 'Si la ubicación que quieres ingresar no coincide con la que se muestra en el mapa, ajusta el localizador sobre la ubicación correcta.',
  },
];

const VacantestLocationTips = () => (
  tips.map((tip) => (
    <div className={vStyles.vacantest__tip} key={tip.title}>
      <div className={vStyles.vacantest__tip__icon}>
        <img src={tipsIcon} alt="tips" />
      </div>
      <div className={vStyles.vacantest__tip__title}>
        <p>{tip.title}</p>
      </div>
      <div className={vStyles.vacantest__tip__content}>
        <p>{tip.content}</p>
      </div>
    </div>
  ))
);

export default VacantestLocationTips;
